export const I18N_NS_PILOTAGE_RH = "pilotage_rh";

/* ---------- Filtres ---------- */
/* Clés = valeurs attendues par l'API (param `period`) */
export const PERIODES = [
    { key: "ytd", header: "Year-to-date" },
    { key: "12m", header: "12 mois glissants" },
    { key: "quarter", header: "Trimestre en cours" },
    { key: "month", header: "Mois en cours" },
];

/* Départements des données de démonstration (le filtre utilise /services/list) */
export const DEPARTEMENTS = [
    "Délégation",
    "Service technique (SPID)",
    "Ventes",
    "Comptabilité et finances",
    "Direction",
    "Conseil et IA",
    "Logistique",
    "Bbalanced",
];

export const DEFAULT_FILTERS = {
    period: "ytd",
    agency_id: null,
    manager_id: null,
    department_id: null,
};

/* Poids (données de démonstration des sections non branchées) */
export const DEPT_WEIGHT = {
    Délégation: 0.48,
    "Service technique (SPID)": 0.19,
    Ventes: 0.11,
    "Comptabilité et finances": 0.06,
    Direction: 0.05,
    "Conseil et IA": 0.04,
    Logistique: 0.07,
    Bbalanced: 0.02,
};
export const PERIODE_WEIGHT = {
    ytd: 1,
    "12m": 1.9,
    quarter: 0.28,
    month: 0.09,
};

/* ---------- Sections ---------- */
export const SECTIONS = {
    effectif: { id: "sec-effectif", title: "Effectif & Structure" },
    diversite: { id: "sec-diversite", title: "Diversité & Démographie" },
    retention: { id: "sec-retention", title: "Rétention & Ancienneté" },
    mouvements: { id: "sec-mouvements", title: "Mouvements & Turnover" },
    absences: { id: "sec-absences", title: "Absentéisme" },
    temps: { id: "sec-temps", title: "Temps de travail" },
    engagement: { id: "sec-engagement", title: "Engagement" },
    frais: { id: "sec-frais", title: "Notes de frais" },
    taches: { id: "sec-taches", title: "Tâches & Suivi" },
};

/* ---------- Définition des KPI ---------- */
/* label, définition, unité, type de calcul (inst | moy | cum) */
export const KPI = {
    headcount: { label: "Headcount", unit: "collab.", calc: "inst" },
    etp: { label: "ETP", unit: "ETP", calc: "inst" },
    effectif_moyen: { label: "Effectif moyen", unit: "collab.", calc: "moy" },
    evolution_effectif: {
        label: "Évolution de l’effectif",
        unit: "%",
        calc: "cum",
    },
    age_moyen: { label: "Âge moyen", unit: "ans", calc: "inst" },
    femmes_management: {
        label: "Femmes au management",
        unit: "%",
        calc: "inst",
    },
    anciennete: { label: "Ancienneté moyenne", unit: "ans", calc: "inst" },
    mobilite: { label: "Taux de mobilité interne", unit: "%", calc: "cum" },
    absences_jour: { label: "Absences du jour", unit: "collab.", calc: "inst" },
};

/* ---------- Export ---------- */
export const EXPORT_FORMATS = [
    { key: "xlsx", header: "Excel (.xlsx)" },
    { key: "pdf", header: "PDF (.pdf)" },
];

/* Clés = codes attendus par l'API (param `sections`) ; engagement est accepté mais ignoré */
export const EXPORT_SYNTHESE_OPTIONS = [
    { key: "effectif", label: "Effectif & Structure" },
    { key: "diversite", label: "Diversité & Démographie" },
    { key: "retention", label: "Rétention & Ancienneté" },
    { key: "mouvements", label: "Mouvements & Turnover" },
    { key: "absenteisme", label: "Absentéisme" },
    { key: "temps-travail", label: "Temps de travail" },
    { key: "engagement", label: "Engagement" },
    { key: "frais", label: "Notes de frais" },
    { key: "taches", label: "Tâches & Suivi" },
];

/* Clés = valeurs attendues par l'API (param `compare_by`) */
export const EXPORT_COMPARE_BY = [
    { key: "department", header: "Département" },
    { key: "agency", header: "Agence" },
    { key: "manager", header: "Manager" },
    { key: "none", header: "Aucune (global)" },
];

/* Clés des options = codes attendus par l'API (param `fields`) */
export const EXPORT_DETAIL_GROUPS = [
    {
        key: "profil",
        label: "Profil",
        toggleable: false,
        options: [
            { key: "nom_prenom", label: "Nom, Prénom", checked: true },
            { key: "role", label: "Rôle", checked: true },
            { key: "poste", label: "Poste", checked: true },
            { key: "departement_agence", label: "Département / Agence", checked: true },
            { key: "type_contrat", label: "Type de contrat", checked: true },
            { key: "date_arrivee", label: "Date d'arrivée", checked: true },
            { key: "anciennete", label: "Ancienneté", checked: true },
            { key: "fin_periode_essai", label: "Fin période d'essai", checked: true },
            { key: "date_naissance", label: "Date de naissance", checked: true },
            {
                key: "categorie_professionnelle",
                label: "Catégorie professionnelle",
                checked: true,
            },
            { key: "genre", label: "Genre", checked: true },
            { key: "taux_activite", label: "Taux d'activité", checked: true },
            { key: "inactif", label: "Inactif", checked: false },
            { key: "date_depart", label: "Date de départ", checked: false },
        ],
    },
    {
        key: "absenteisme",
        label: "Absentéisme",
        toggleable: true,
        options: [
            { key: "nombre_jours_absence", label: "Nombre de jours" },
            { key: "motifs_absence", label: "Motif(s)" },
            { key: "duree_absence", label: "Durée" },
            { key: "frequence_absence", label: "Fréquence" },
            { key: "solde_vacances", label: "Solde de vacances" },
        ],
    },
    {
        key: "mouvements",
        label: "Mouvements & Turnover",
        toggleable: true,
        options: [
            { key: "statut", label: "Statut" },
            { key: "motif_depart", label: "Motif de départ" },
            { key: "type_turnover", label: "Type de turnover" },
        ],
    },
    {
        key: "temps",
        label: "Temps de travail",
        toggleable: true,
        options: [
            { key: "heures_contractuelles", label: "Heures contractuelles" },
            { key: "heures_declarees", label: "Heures déclarées" },
            { key: "heures_supplementaires", label: "Heures supplémentaires" },
            { key: "jours_teletravail", label: "Jours télétravail" },
        ],
    },
    {
        key: "frais",
        label: "Notes de frais",
        toggleable: true,
        options: [{ key: "montant_total_frais", label: "Montant total" }],
    },
];

/* ---------- Masquage des indicateurs (GET/POST /hr/pilotage/indicators) ---------- */
/* Codes indicateurs attendus par l'API */
export const INDICATORS = {
    headcount: "headcount",
    etp: "etp",
    effectif_moyen: "effectif_moyen",
    evolution_effectif: "evolution_effectif",
    repartition_contrat: "repartition_contrat",
    repartition_departement: "repartition_departement",
    categorie_professionnelle: "categorie_professionnelle",
    taux_activite: "taux_activite",
    pyramide_ages: "pyramide_ages",
    repartition_genre: "repartition_genre",
    age_moyen: "age_moyen",
    femmes_management: "femmes_management",
    taux_retention: "taux_retention",
    confirmation_periode_essai: "confirmation_periode_essai",
    recrutement_reussi_12_mois: "recrutement_reussi_12_mois",
    anciennete_moyenne: "anciennete_moyenne",
    taux_mobilite_interne: "taux_mobilite_interne",
    entrees_sorties: "entrees_sorties",
    decomposition_turnover: "decomposition_turnover",
    onboarding_offboarding: "onboarding_offboarding",
    absences_vs_jours_travailles: "absences_vs_jours_travailles",
    absenteisme: "absenteisme",
    absences_par_motif: "absences_par_motif",
    heures_realisees: "heures_realisees",
    heures_supplementaires: "heures_supplementaires",
    teletravail: "teletravail",
    enps: "enps",
    repartition_categorie: "repartition_categorie",
    absences_du_jour: "absences_du_jour",
    soldes_vacances: "soldes_vacances",
    mouvements_en_cours: "mouvements_en_cours",
    validation_feuilles_temps: "validation_feuilles_temps",
    envoi_feuilles_temps: "envoi_feuilles_temps",
    taches_echeance: "taches_echeance",
};

/* id de section -> code de groupe d'indicateurs */
export const INDICATOR_GROUP_BY_SECTION = {
    [SECTIONS.effectif.id]: "effectif_structure",
    [SECTIONS.diversite.id]: "diversite_demographie",
    [SECTIONS.retention.id]: "retention_anciennete",
    [SECTIONS.mouvements.id]: "mouvements_turnover",
    [SECTIONS.absences.id]: "absenteisme",
    [SECTIONS.temps.id]: "temps_travail",
    [SECTIONS.engagement.id]: "engagement",
    [SECTIONS.frais.id]: "notes_frais",
    [SECTIONS.taches.id]: "taches_suivi",
};

/* Groupes non affichés sur la page (EngagementSection désactivée) */
export const EXCLUDED_INDICATOR_GROUPS = ["engagement"];
